const StudyEnglishfor =() =>{
    return(
        <>
        <div className="container-fluid bg-primary py-5 mb-5 page-header">
        <div className="container py-5">
            <div className="row justify-content-center">
                <div className="col-lg-10 text-center">
                    <h1 className="display-3 text-white animated slideInDown">Study English For Beginners</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb justify-content-center"><li className="">
    <a className="text-white" href="">Home</a>
  </li>

  <li className=" text-white">
    <i className="fa fa-arrow-right mx-2"></i>
  </li>

  <li className=" active text-white" aria-current="page">
    Study in English For Beginners
  </li>
                        </ol>
                    </nav>
                </div>
            </div>
        </div>
    </div>

    <div className="container-xxl py-5">
        <div className="container">
            <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
                <h6 className="section-title bg-white text-center text-primary px-3"></h6>
                <h1 className="mb-5">Study in India For Beginners</h1>
            </div>
            
            <div className="wow fadeInUp" data-wow-delay="0.2s">
    <div className="row">
        <div className="col-lg-12 wow fadeInUp" data-wow-delay="0.5s">
            <div className="card why-choose-card border-0 shadow h-100 p-4">

                <p className="mb-3">
                    Study English for beginners is a program designed by and provided by MCM College in order to overcome obstacles to slice students beginners in the study of English and who have neither any prior knowledge of the English language, and it is known the size of the extreme difficulty faced by the student and the teacher in this way because it student does not have the a minimum of knowledge in the language and the teacher will certainly foreigner does not speak in a language student Momma (and not Arabic, for example) in order to deliver the idea to the student and thus highlight here the problem, and it was put this program in order to solve this complex problem and was for this program amazing results.

                </p>

                <div className="row align-items-start">
    
    <div className="col-lg-8 wow fadeInUp" data-wow-delay="0.3s">
        <p className="mb-4">
            The duration of this program just one month and through the student learns ABC English and sections of English and how to form sentences and so on from the ABCs of language, and after that pass student this basic course will be attachable levels most advanced, through this program is the use of a team of experts and professors speaking in both English and the language of the student mother (but not Arabic, for example) in order to facilitate the task and get the idea to the student without any trouble, and, of course, beside the British professors, mainly foreigners.                </p>
    </div>

    <div className="col-lg-4 wow fadeInUp" data-wow-delay="0.5s">
        <div className="card facility-card shadow">
            <img src="https://images.unsplash.com/photo-1521587760476-6c12a4b040da?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
                 className="card-img-top facility-img"
                 alt="University Library" />
        </div>
    </div>
    <p className="mb-4">English Learning Software for Beginners is among one of the most programs adopted by the institution and to the utmost importance for foreign students coming to the Republic of India in order to receive the flag and in particular those who are have neither any prior knowledge of the English language, and Arab students the brunt of it has been taken into account through the process of preparing the program and make it suitable to the needs of this segment of the Arab students, where as mentioned earlier in this program are hired professors speaking both English and the language of the student mother in this case the native language of the student will be Arabic, and to that use professors and Arab experts with experience in this area, next to the British and professors mainly foreigners.</p> <div className="row align-items-start">
</div>
    {/* <p className="mb-4"> */}
{/* 6. India because of its natural beauty and atmosphere is almost mild in most cases and in many Indian states</p> */}


    <div className="col-lg-4 wow fadeInUp" data-wow-delay="0.5s">
        <div className="card facilitylist-card shadow">
            <img src="https://images.unsplash.com/photo-1521587760476-6c12a4b040da?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80"
                 className="card-img-top facilitylist-img"
                 alt="University Library" />
        </div>
    </div>
    <div className="col-lg-8 wow fadeInUp" data-wow-delay="0.3s">
        <p className="mb-4">Features make you that join this program: </p>

<li>professors with experience in the field of English language teaching for beginners (students do not hold any prior knowledge of language) and holders of master's degrees and doctorate and have versatility in language and teaching experience abroad and there have experience teaching at least for a period of 5 years in this area, in addition to providing British teachers and who possess the qualifications and skills is very high in English language teaching for non-native speakers.</li>

<li>class rooms comfortable, spacious and equipped with the latest equipment, and small numbers of different nationalities, from 8 to 15 students in each class.</li>

<li>Language Lab is available mail (Computer lab is equipped for this purpose with the latest equipment), and are also available at the same Internet service laboratory.</li>

<li>provide the student with all the school supplies of books and electronic media and educational school bag, and provide a rich library of books related to this field.</li>

<li>systems used in this study center is Oxford and Cambridge systems.</li>
<br />Study English is not difficult task, but at the same time Hnlk dire need of an environment appropriate where there is all the factors helping in the success of the mission and get tangible results and fast, the environment provided by MCM College is the best ever in terms available environment and conditions favorable for learning English and during almost be short compared to other institutes and colleges engaged in the same field.
<p className="mb-4">Those interested in enrollment MCM please contact us at the following email address:
info@mcmcollege.com</p>
    </div>
</div>
</div>
        </div>
    </div>
</div>
        </div>
    </div>

        </>
    )
}
export default StudyEnglishfor;